import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { AssignmentCreationInfo, CreateMultipleAssignmentsContext } from "./createMultipleAssignments";
import { Grid } from "../core/components/grid"
import { Helper } from "../core/util/helper";
import React from "react"

export default class AssignmentPeriodPreview extends React.Component<AssignmentPeriodPreviewProps, AssignmentPeriodPreviewState>{

    private gridOptions: kendo.ui.GridOptions;

    constructor(props: AssignmentPeriodPreviewProps) {
        super(props)
        this.state = {
            info: JSON.parse(JSON.stringify(props.value)),
            gridData: [],
            preview: null,
            message: null
        }

        this.initApp();
    }

    private initApp = () => {
        this.gridOptions = {
            dataSource: {
                pageSize: 8
            },
            sortable: true,
            pageable: true,
            groupable: false,
            filterable: true,
            selectable: true,
            resizable: true,
            scrollable: true,
            columns: [
                {
                    field: "Item1",
                    title: this.props.context.translations["Field.BelegZeit.zvon"],
                    template: "#= kendo.toString(kendo.parseDate(Item1), 'g') #"
                },
                {
                    field: "Item2",
                    title: this.props.context.translations["Field.BelegZeit.zbis"],
                    template: "#= kendo.toString(kendo.parseDate(Item2), 'g') #"
                }
            ]
        };
    }

    private getData = async () => {
        this.setState({ preview: Preview.None }, async () => {
            const result = await HTTPService.noBusyIndicator().post<JsonResultClass<any[]>>('CreateMultipleAssignments/GetPreviewData', { info: this.state.info })
            if (result.Code == 0) {
                this.setState({ gridData: result.Data, message: null, preview: Preview.Loaded })
            } else {
                this.setState({ gridData: [], message: result.Message, preview: Preview.Error })
            }
        })
    }

    componentDidMount() {
        if (Helper.hasValue(this.state.info))
            this.getData();
    }

    componentDidUpdate() {
        if (JSON.stringify(this.props.value) !== JSON.stringify(this.state.info)) {
            this.setState({ info: JSON.parse(JSON.stringify(this.props.value)) }, this.getData)
        }
    }

    private renderGrid = () => {
        return (
            <div className="flex-container">
                <Grid
                    data={this.state.gridData}
                    options={this.gridOptions}
                    id="assignmentPeriodPreviewGrid"
                />
            </div>
        );
    }


    private renderError = () => {
        return (
            <div style={{ display: "grid" }}>
                <div style={{ display: "flex", justifyContent: "center", gridArea: "1/1/1/1" }}>
                    <i className="fal fa-times fa-10x" style={{ opacity: 0.1 }}></i>
                </div>
                <div style={{ textAlign: "center", gridArea: "1/1/1/1", paddingTop: "40px" }}>
                    <label style={{ fontSize: "15px" }}>
                        {this.state.message}
                    </label>
                </div>
            </div>
        );
    }



    render() {
        switch (this.state.preview) {
            case Preview.Loaded:
                return this.renderGrid();
            case Preview.Error:
                return this.renderError();
            case Preview.None:
            default:
                return null;
        }
    }
}

interface AssignmentPeriodPreviewProps {
    value: AssignmentCreationInfo;
    context: CreateMultipleAssignmentsContext;
}

interface AssignmentPeriodPreviewState {
    info: AssignmentCreationInfo;
    gridData: { Item1, Item2 }[];
    preview: Preview;
    message?: string;
}

enum Preview {
    None,
    Loaded,
    Error
}